import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Style from "./Menu.module.scss";
import DesktopNav from "./DesktopNav";
import MobileMenu from "./MobileMenu";
import { useSelector } from "react-redux";
import { useSearch } from "../../../logic/useSearch";

import { useDimensions } from "../../../logic/Dimensions";
import Search from "./Search";
import { useHeader } from "../../../logic/useHeader";
import { useCurrencyGraph } from "../../../logic/useCurrencyGraph";

const Menu = () => {
  const {
    activeSearch,
    setActiveSearch,
    openSearch,
    closeSearch,
    searchTerm,
    searchHandleChange,
    searchData,
    setSearchTerm,
  } = useSearch();

  const { graphData, graphOptions, graphDays } = useCurrencyGraph();
  const { menuData } = useHeader();
  const { width } = useDimensions();

  const [active, setActive] = useState("");
  const [isSlim, setIsSlim] = useState(false);

  const location = useLocation();
  const windowDimension = useDimensions();


  useEffect(() => {
    setTimeout(() => {
      setActive(Style.loaded);
    }, 1000);
  }, []);

  const menuSelect = () => {
    document.body.classList.remove("show-menu");
  };

  const { isActive } = useSelector((state) => state.menu);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      let scroll = window.pageYOffset;
      scroll > 50 ? setIsSlim(true) : setIsSlim(false);
    });
  }, []);

  return (
    <div
      className={`${Style.siteheader} ${Style.loaded} ${
        location.pathname === "/" && Style.siteheader_home
      } site-header`}
    >
      <div className={`container ${Style.siteheader_container}`}>
        <div className={`${Style.headerwrap} header-wrap`}>
          <div className={Style.logosec}>
            {isActive ? (
              <Link to="/" onClick={menuSelect}>
                {windowDimension.width >= 1200 &&
                graphData &&
                graphOptions &&
                graphDays &&
                location?.pathname == "/" ? (
                  isSlim ? (
                    <img src={menuData?.site_logo?.url} alt="header logo" />
                  ) : (
                    <img src={menuData?.white_site_logo?.url} alt="header logo" />
                  )
                ) : (
                  <img src={menuData?.site_logo?.url} alt="header logo" />
                )}
              </Link>
            ) : (
              <Link to="/" onClick={menuSelect}>
                {windowDimension.width >= 1200 &&
                graphData &&
                graphOptions &&
                graphDays &&
                location?.pathname == "/" ? (
                  isSlim ? (
                    <img src={menuData?.site_logo?.url} alt="header logo" />
                  ) : (
                    <img src={menuData?.white_site_logo?.url} alt="header logo" />
                  )
                ) : (
                  <img src={menuData?.site_logo?.url} alt="header logo" />
                )}
              </Link>
            )}
          </div>
          <div
            className={
              activeSearch
                ? `${Style.headeright} search_open`
                : Style.headeright
            }
          >
            {width < 1200 && (
              <Search
                closeSearch={closeSearch}
                openSearch={openSearch}
                searchTerm={searchTerm}
                searchHandleChange={searchHandleChange}
                searchData={searchData}
                setSearchTerm={setSearchTerm}
                setActiveSearch={setActiveSearch}
              />
            )}
            <DesktopNav
              activeSearch={activeSearch}
              closeSearch={closeSearch}
              openSearch={openSearch}
              setActiveSearch={setActiveSearch}
              searchTerm={searchTerm}
              searchHandleChange={searchHandleChange}
              searchData={searchData}
              setSearchTerm={setSearchTerm}
              menuData={menuData}
            />
            <MobileMenu menuData={menuData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
